<template>
  <div class="layout-col">
    <section class="-wrapper-tile -wrapper-column -h-center-">
      <div class="-header">
        <div v-if="'AM'=== userInfo.auth">
          <p class="-h2 -font-weight-medium">{{ $t('pages_dashboard_contract_cost_last_month.title')}}

            <g-tooltip-wrapper>
              <g-icon name="info" color="gray-1" class="-ml-1"></g-icon>
              <g-tooltip direction="right">
                <span v-html="$t('pages_dashboard_contract_top3.tooltip')" />
              </g-tooltip>
            </g-tooltip-wrapper>
          </p>
        </div>
        <div v-else>
          <p class="-h2 -font-weight-medium">{{ $t('pages_dashboard_contract_cost_last_month.title.AM')}}
            <g-tooltip-wrapper>
              <g-icon name="info" color="gray-1" class="-ml-1"></g-icon>
              <g-tooltip direction="right">
                <span v-html="$t('pages_dashboard_contract_top3.tooltip')" />
              </g-tooltip>
            </g-tooltip-wrapper>
          </p>
        </div>


      </div>
      <div class="-wrapper-column -wrapper-v-h-center -width-100 -height-dashboard-1 -px-5 -py-4">
        <div class="-wrapper -wrapper-v-h-center">
          <p class="-font-size-14 -font-weight-medium">{{ $t('pages_dashboard_contract_cost_last_month.count')}}</p>
          <p id="dashboard-contract-top3-contract-count" class="-number l- -ml-5">{{ contractTopTotal | comma }}</p>
        </div>
        <div class="-wrapper -width-100 -mt-2" id="dashboard-contract-top3-list">
          <div v-for="(top, index) in contractTopList" :key="top.contractName" class="-wrapper -wrapper-v-center between- -width-100 -px-4 -border-bottom -list-item-height-40" style="cursor:pointer;">
            <div class="-wrapper v-center- " style="width: calc(100% - 95px);" @click="moveContract(top)" :id="'dashboard-contract-top3-click-move-'+top.constractCode">
              <span class="-font-size-12">{{ index + 1 }}.</span>
              <span :id="'dashboard-contract-top3-'+top.contractName" class="-ml-4 -font-size-14 -ellipsis " style=" line-height: 1.125; flex: 1">{{ top.contractName }}</span>
            </div>
            <p :id="'dashboard-contract-top3-trade-amount-'+top.constractCode" class="-font-size-12 text-right- -color-gray-1" style="width: 95px;">{{ top.totalTradeAmountByKrw | comma }}{{$t('pages_dashboard_contract_cost_last_month.currency')}}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import moment from "moment";
import {AUTH_GROUP} from "@/constants/constants";

export default {
  name: 'contact-cost-list-last-month',
  componentName: 'ContactCostListLastMonth',
  data () {
    return {
      contractTopList: [],
      contractTopTotal: '0'
    }
  },
  computed: {
    ...mapGetters('dashboard', ['contractTop', 'contractTopCount']),
    ...mapGetters('user', ['userInfo']),
  },
  watch: {
    contractTop() {
      this.contractTopList = this.contractTop
      this.contractTopTotal = this.contractTopCount
    }
  },
  methods: {
    moveContract(item) {
      if(AUTH_GROUP.AccountManager === this.userInfo.auth){
        this.$router.push(`/contract/detail?id=${item.constractCode}&companyCode=${this.userInfo.companyCode}&customerCode=${this.userInfo.customerCode + this.userInfo.customerDeptCode}&empNo=${this.userInfo.empNo}&month=`+moment(new Date).add("-1", "M").format("YYYYMM"))
      }else{
        this.$router.push(`/contract/detail?id=${item.constractCode}&companyCode=${this.userInfo.companyCode}&empNo=${this.userInfo.empNo}&month=`+moment(new Date).add("-1", "M").format("YYYYMM"))
      }
    }
  },

}
</script>
<style scoped>
  .layout-col {
    flex: 1;
    width: 0;
  }
</style>>



// WEBPACK FOOTER //
// src/pages/home/components/ContactCostLastMonth.vue